import { Component, inject, signal } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ApiService } from '../../api.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TAGInvTransaction } from '../../../models/taginventory';
import { MessageService } from 'primeng/api';
import { InvTransactionListItemComponent } from '../../components/inv-transaction-list-item/inv-transaction-list-item';

@Component({
  selector: 'int-inv-transaction-import-dialog',
  imports: [
    SkeletonModule,
    DialogModule,
    ButtonModule,
    TranslatePipe,
    InvTransactionListItemComponent,
  ],
  providers: [TranslateService],
  templateUrl: './InvTransactionImportDialog.html',
  styleUrl: './InvTransactionImportDialog.scss',
})
export class InvTransactionImportDialog {
  private translate = inject(TranslateService);
  private messageService = inject(MessageService);
  private api = inject(ApiService);

  transactions = signal<TAGInvTransaction[]>([]);
  loading = signal(true);

  constructor(
    public dialogRef: DynamicDialogRef<InvTransactionImportDialog>,
    public config: DynamicDialogConfig<void>,
  ) {
      config.header = this.translate.translate('internal.events.importInvTitle')();
    }

  ngOnInit() {
    this.api.waitForAPI().then(() => {
      this.api
        .getInvTransactions()
        .then((transactions: TAGInvTransaction[]) => {
          transactions.sort((a, b) => {
            return a.startdate > b.startdate ? -1 : 1;
          });

          this.transactions.set(transactions.filter((t) => t.event === undefined || t.event === ""));
          this.loading.set(false);
        })
        .catch((reason) => {
          this.messageService.add({
            severity: 'danger',
            summary: this.translate.translate("errors.couldNotLoadInventoryTransactions")(),
            detail: reason.message,
          });
        });
    });
  }

  selectedTransaction(transaction: TAGInvTransaction) {
    this.dialogRef.close(transaction);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
